import { Device } from '@capacitor/device';
import { compareVersions } from 'compare-versions';
import p from '../../../package.json';

export const goToDeviceAppropriateAppStore = async () => {
  const device = await Device.getInfo();

  if (!device) {
    console.warn('No device info retrieved');
    return;
  }

  if (device.operatingSystem.toLowerCase() === 'android') {
    window.open('https://play.google.com/store/apps/details?id=com.otuvy.frontline');
  } else if (device.operatingSystem.toLowerCase() === 'ios') {
    window.open('https://apps.apple.com/app/otuvy-frontline/id6461824661');
  } else if (device.operatingSystem.toLowerCase() === 'windows') {
    //This usually happens when running inside a browser rather than actually ondevice
    console.log("OS 'windows' detected. Not taking any actions, though the user should CTL+F5");
  } else if (device.operatingSystem.toLowerCase() === 'web') {
    //TODO: what should we do here? Prompt to refresh?
    //This should be an edge case so I am just logging it for now
    console.log("OS 'web' detected. Not taking any actions, though the user should CTL+F5");
  } else {
    console.warn('Unhandled OS', device.operatingSystem);
  }
};

export const determineIfUpdateNeeded = (checkingVersion: string | undefined): boolean => {
  if (!checkingVersion || checkingVersion === '0.0.0') return false;

  const currentlyInstalledVersion = p.version;

  try {
    return compareVersions(currentlyInstalledVersion, checkingVersion) < 0;
  } catch (e) {
    console.error(e);
  }

  return false;
};
